import { Link, useLocation } from "react-router-dom";
import { Tooltip } from "@mui/material";
import { IconChevronRight, IconPoint } from "@tabler/icons-react";

const Navigator = (props) => {
  const location = useLocation();

  const { name, path, navIcon, onClick ,navSVG,navIconImg , liClass , path2 , activeArrList} = props;

  // console.log("location-->" , location);
  // console.log("activeArrList-->" , activeArrList);

  return (
    // <li onClick={onClick} key={`navHade`}>
    //   <Tooltip title={name} placement="right" >
    //     <Link
    //       to={{ pathname: path }}
    //       className={`${location.pathname === path && "activeMenu"} betBox`}
    //     >
    //       <div>
    //         {navIconImg ? (
    //             <>
    //               <img src={navIconImg} alt=""/>
    //             </>
    //           ) : navIcon ? (
    //             <>
    //               <i className={navIcon}></i>
    //             </>
    //           ) : (
    //             <>{navSVG}</>
    //           )}
    //         <span className="text-capitalize ms-3 my-auto">{name}</span>
    //       </div>
    //       {props?.children && <i className="ri-arrow-right-s-line fs-18"></i>}
    //     </Link>
    //   </Tooltip>
    //   {/* If Submenu */}
    //   <Tooltip title={name} placement="right">
    //     {props.children}
    //   </Tooltip>
    // </li>

     <ul className="mainMenu">
      <li onClick={onClick} className={liClass}>
        <Tooltip title={name} placement="right">
          <Link
            to={{ pathname: path }}
            // className={`${location.pathname === path ? location.pathname === path && "activeMenu" : location.pathname === path2 && "activeMenu"}`}
            className={activeArrList?.includes(location.pathname) ? "activeMenu" : ""}
          >
            <div> 
              {navIcon}
              <span className="text-capitalize">{name}</span>
            </div>
            
            {props?.children && <IconChevronRight />}
          </Link>
        </Tooltip>
        {/* If Submenu */}
        <ul className={`subMenu transform0`}>
          {props.children?.map((res) => {
            const { subName, name , path , onClick } = res?.props;
            return (
              <>
                <Tooltip title={name}  placement="right">
                  <li>
                    <Link
                      to={{ pathname: path }}
                      className={`${
                        location.pathname === path && "activeMenu"
                      }`}
                      onClick={onClick}
                    >
                     <IconPoint/>
                      <span style={{ fontSize: "14px" }}>{name}</span>
                    </Link>
                  </li>
                </Tooltip>
              </>
            );
          })}
        </ul>
      </li>
    </ul>
  );
};

export default Navigator;